import React, { useState } from 'react';
import ContactForm from './ContactForm';
import { SiriusHtmlModal } from '@web-common/components/UI/Modal/SiriusModal';
import styles from './personalModal.module.scss';
import { api, locationHelper } from 'api';
import { getIn18Text } from 'api';
const systemApi = api.getSystemApi();
export const PersonalModal = (props) => {
    var _a;
    const { isEdit, contactId, contact, onCancel, onSuccess, from = 'contact', _account = ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '' } = props;
    const [visible, setVisible] = useState(true);
    const [title, setTitle] = useState(isEdit ? getIn18Text('BIANJILIANXIREN') : getIn18Text('XINJIANLIANXIREN'));
    const isGlobal = locationHelper.testPathMatch('/readMail');
    return (React.createElement(SiriusHtmlModal, { width: 480, isGlobal: isGlobal, visible: visible, destroyOnClose: false, footer: null, closable: false, getContainer: () => {
            return document.body;
        } },
        React.createElement("div", { className: styles.wrap, "data-test-id": "modal_personal", onClick: e => {
                return e.stopPropagation();
            } },
            React.createElement("div", { className: styles.title },
                React.createElement("div", { className: styles.name, "data-test-id": "modal_personal_title" }, title),
                React.createElement("div", { className: `dark-invert ${styles.close}`, onClick: onCancel })),
            React.createElement("div", { className: styles.content, onClick: e => {
                    return e.stopPropagation();
                } },
                React.createElement(ContactForm, { from: isEdit ? 'edit' : 'create', _account: _account, contact: contact, contactId: contactId, onSuccess: onSuccess, onCancel: onCancel, onChangeVisible: (open) => setVisible(open), onChangeTitle: (str) => setTitle(str) })))));
};
